import {
	CerrarSesion,
	Nav,
	NavGroup,
	NavItem,
	NavTitle,
	Spacer,
} from "../LeftMenu";
import {
	assignmentAdd,
	resetSettings,
	speed,
	assignmentList,
	DashboardCustomize,
	Calendar,
} from "@/assets/icons/Icons";

export function MainUserMenu() {
	return (
		<Nav>
			<NavTitle>Gestor Huella de Carbono</NavTitle>
			<NavGroup>
				<NavItem
					title="Dashboard"
					description="Visualiza los KPIs de CO2 y compara con otras empresas del cluster."
					url="/user/dashboard"
					icon={speed}
				/>
				<NavItem
					title="Imputaciones"
					description="Listado y edición de las imputaciones realizadas."
					url="/user"
					icon={assignmentList}
				/>
				<NavItem
					title="Nueva Imputación"
					description="Crea una nueva imputación basada en la configuración de tu empresa."
					url="/user/input/new"
					icon={assignmentAdd}
				/>
			</NavGroup>
			<NavItem
				title="Datos Anuales"
				description="Listado y edición de datos de la empresa."
				url="/user/empresa"
				icon={Calendar}
			/>

			<Spacer />

			<NavGroup>
				<NavItem
					title="Emisores de Co2"
					description="Modifica la configuración de emisiones de tu empresa."
					url="/user/config"
					icon={resetSettings}
				/>
				<NavItem
					title="Factores Personalizados"
					description="Gestiona tus factores de emisión personalizados."
					url="/user/configFactores"
					icon={DashboardCustomize}
				/>
			</NavGroup>

			<CerrarSesion />
		</Nav>
	);
}
